import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { DateFormatter } from '@/support/DateFormatter';

@Component<OverwriteDateDialog>({})
export default class OverwriteDateDialog extends Vue {
  @Prop()
  protected title!: string;

  protected date: DateFormatter = new DateFormatter();

  protected reason = '';

  protected isLoading = true;

  // protected AppointmentEnum = AppointmentEnum;

  protected async mounted(): Promise<void> {
    this.isLoading = false;
  }

  protected close(): void {
    this.$emit('input', false);
  }

  protected async overwriteDate(): Promise<void> {
    const event: OverwriteDateEvent = {
      date: `${this.date.selectedDate} ${this.date.selectedTime}`,
      reason: this.reason,
    };

    this.$emit('overwriteDate', event);
  }

  protected get isValid(): boolean {
    return !! (this.date && this.date.selectedDate && this.reason);
  }
}

export type OverwriteDateEvent = {
  date?: string;
  reason?: string;
}
